<template>
  <v-app>
    <v-app-bar app color="black" dark elevation="4">
      <v-app-bar-nav-icon @click="toggleDrawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link to="/" class="white--text text-decoration-none  font-weight-bold">skintock</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      
      <!-- <v-btn icon @click="$router.push('/products')">
        <v-icon>mdi-magnify</v-icon>
      </v-btn> -->
      
      <!-- <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-badge :content="cartItemCount" :value="cartItemCount" color="accent" overlap>
              <v-icon>mdi-cart</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-card min-width="320">
          <v-list>
            <v-list-item v-if="cart.length === 0">
              <v-list-item-content>
                <v-list-item-title>장바구니가 비어있습니다</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
            <template v-else>
              <v-list-item v-for="item in cart" :key="item.product.id">
                <v-list-item-avatar>
                  <v-img v-if="item.product.images && item.product.images.length" 
                         :src="item.product.images.find(img => img.is_primary)?.image || item.product.images[0].image">
                  </v-img>
                  <v-icon v-else>mdi-image</v-icon>
                </v-list-item-avatar>
                
                <v-list-item-content>
                  <v-list-item-title>{{ item.product.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ numberWithCommas(item.product.discount_price || item.product.price) }}원 x {{ item.quantity }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                
                <v-list-item-action>
                  <v-btn icon @click="removeFromCart(item.product.id)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              
              <v-divider></v-divider>
              
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">총액: {{ numberWithCommas(cartTotal) }}원</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn color="primary" text>결제하기</v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-menu> -->
    </v-app-bar>
    
    <v-navigation-drawer v-model="drawer" app temporary>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">skintock</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      
      <v-divider></v-divider>
      
      <v-list nav dense>
        <v-list-item to="/" link>
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>홈</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <!-- <v-list-item to="/products" link>
          <v-list-item-icon>
            <v-icon>mdi-package-variant-closed</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>전체 제품</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        
        <!-- <v-list-group prepend-icon="mdi-tag" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>카테고리</v-list-item-title>
            </v-list-item-content>
          </template>
          
          <v-list-item v-for="category in categories" :key="category.id" :to="`/category/${category.id}`" link>
            <v-list-item-content>
              <v-list-item-title>{{ category.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group> -->
        
        <!-- <v-list-item to="/events" link>
          <v-list-item-icon>
            <v-icon>mdi-calendar-star</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>이벤트</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        
        <v-list-item to="/contact" link>
          <v-list-item-icon>
            <v-icon>mdi-email</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>문의하기</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    
    <v-main>
      <router-view></router-view>
    </v-main>
    
    <v-footer padless>
      <v-card flat tile width="100%" class="text-center">
        <v-card-text>
          <v-btn v-for="icon in icons" :key="icon" icon>
            <v-icon>{{ icon }}</v-icon>
          </v-btn>
        </v-card-text>
        <v-divider/>
        <v-card-text class="mx-6 my-3">
          <v-row>
            <v-col cols="12" md="6" lg="6" class="text-left">
              <span class="caption font-weight-bold">CUSTOMER CENTER</span><br/>
              <strong class="text-h6  font-weight-bold">
                070-8098-4108
              </strong><br/>
              <span class="caption">MON-FRI : AM 10:00 ~ PM 05:00 / SAT, SUN, HOLIDAY OFF</span><br/>
              <span class="caption">LUNCH : AM 11:30 ~ PM 01:30</span>
            </v-col>
            <v-col cols="12" md="6" lg="6" class="text-left">
              <span class="caption font-weight-bold">COMMUNITY</span><br/>
              <span class="caption">
                <a href="/notice" class="text--primary">NOTICE</a>
              </span><br/>
              <span class="caption">
                <a href="/review" class="text--primary">REVIEW</a>
              </span><br/>
              <span class="caption">
                <a href="/bulk-order" class="text--primary">BULK ORDER</a>
              </span><br/>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="mx-6"/>
        <v-card-text class="mx-6" style="font-size: 0.7em">
          <v-row dense>
            <v-col cols="12" md="3" lg="3" class="text-left">
              COMPANY : (주)에스현
            </v-col>
            <v-col cols="12" md="3" lg="3" class="text-left">
              CEO : 이현호
            </v-col>
            <v-col cols="12" md="3" lg="3" class="text-left">
              TEL :070-8098-4108
            </v-col>
            <v-col cols="12" md="3" lg="3" class="text-left">
              BUSINESS LICENCE :262-86-00596
            </v-col>
            <v-col cols="12" md="3" lg="3" class="text-left">
              ONLINE LICENCE : 제2025-인천연수구-1581호
            </v-col>
            <v-col cols="12"  class="text-left">
              &copy; {{ new Date().getFullYear() }} - <strong>(주)에스현</strong>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    drawer: false,

    icons: ['mdi-facebook', 'mdi-twitter', 'mdi-instagram']
  }),
  computed: {

  },
  methods: {
    toggleDrawer() {
    this.drawer = !this.drawer;
    }
  },
  created() {
  }
}
</script>